// extracted by mini-css-extract-plugin
module.exports = {"bstRow":"Applications_bstRow__1FGFR","header":"Applications_header__f4mHd"};